import React from 'react';
import { PageLayout } from '@/shared/layout/PageLayout';
import { ReportsKpiDashboard } from './components/ReportsKpiDashboard';
import { ReportsModulesGrid } from './components/ReportsModulesGrid';
import { RecentReportActivity } from './components/RecentReportActivity';

export function ReportsPage() {
  return (
    <PageLayout
      title="Báo cáo & Phân tích"
      description="Trung tâm tổng hợp dữ liệu, báo cáo tiến độ, tài chính và phân tích hiệu suất dự án đa chiều"
    >
      <div className="space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-500">

        {/* Top KPIs Dashboard */}
        <ReportsKpiDashboard />

        {/* Navigation Hub */}
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
          <div className="lg:col-span-8 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-blue-500 rounded-full" />
                Nghiệp vụ Báo cáo (Reporting & Analytics)
              </h3>
            </div>
            <div className="flex-1">
              <ReportsModulesGrid />
            </div>
          </div>

          <div className="lg:col-span-4 flex flex-col gap-6">
            <div className="flex items-center justify-between">
              <h3 className="text-base font-black text-slate-900 flex items-center gap-2">
                <div className="w-2 h-6 bg-amber-500 rounded-full" />
                Hoạt động xuất dữ liệu
              </h3>
              <button className="text-xs font-medium text-blue-600 hover:text-blue-700 hover:underline transition-colors cursor-pointer">
                Xem toàn bộ &rarr;
              </button>
            </div>
            <div className="flex-[2] flex flex-col min-h-0">
              <RecentReportActivity />
            </div>

          </div>
        </div>
      </div>
    </PageLayout>
  );
}

export default ReportsPage;
